import React from 'react';
import SignIn from '../../components/sign-in/SignIn';

const SignInPage = () => (
    <div className='signin-page'>
        <SignIn />
    </div>
)

export default SignInPage;